module.exports = __webpack_public_path__ + "static/samer-4626fb87642a03b91d13b8b7b9b8ea99.jpg";